import { TemplateInstance } from "../TemplateInstance";

export class General extends TemplateInstance {
  constructor(imageIdentifier: string) {
    super("מחפשים עבודה?", "יש לנו משרה בדיוק בשבילך", imageIdentifier);

    this.setImageIdentifier(imageIdentifier).catch((err) =>
      console.error("Error setting image identifier:", err)
    );
  }
}
